const reconHeaderData = [
    {
        label: "KX Id",
        value: "12345678"
    },
    {
        label: "Entry Number",
        value: "12345678"
    },
    {
        label: "Port",
        value: "12345678"
    },
    {
        label: "Import Name",
        value: "test test"
    },
];

const reconStatusIndicatorData = [
    {
        label: "Job Status",
        value: "Complete"
    },
    {
        label: "CBP Status",
        value: "Complete"
    }
]

const reconTypeVal = [
    { key: 'ce1', value: 'CE1', text: 'Change' },
    { key: 'na1', value: 'NA1', text: 'No Change' },
  ]

  const actionTypeVal = [
    { key: 'a', value: 'A', text: 'Add' },
    { key: 'r', value: 'R', text: 'Replace' },
    { key: 'd', value: 'D', text: 'Delete' }
  ]

  const importEntryLocVal = [
    { key: 'us', value: 'US', text: 'United States' },
    { key: 'pr', value: 'PR', text: 'Puerto Rico' },
    { key: 'vi', value: 'VI', text: 'US Virgin Islands' }
  ]

  const paymentTypeCodeVal = [
    { key: '1', value: '1', text: 'Individual Payment' },
    { key: '2', value: '2', text: 'Broker Daily' },
    { key: '3', value: '3', text: 'Importer Daily' },
    { key: '5', value: '5', text: 'Importer Daily (without suffix)' }
  ]
  const dropdownLabelVal = [
    { key: '1', value: 'BEEF FEE', text: 'BEEF FEE' },
    { key: '2', value: 'PORK FEE', text: 'PORK FEE' },
    { key: '3', value: 'HONEY FEE', text: 'HONEY FEE' },
    { key: '4', value: 'COTTON FEE', text: 'COTTON FEE' },
    { key: '5', value: 'RASPBERRY FEE', text: 'RASPBERRY FEE' },
    { key: '6', value: 'SUGAR FEE', text: 'SUGAR FEE' },
    { key: '7', value: 'POTATO FEE', text: 'POTATO FEE' },
    { key: '8', value: 'LIME FEE', text: 'LIME FEE' },
    { key: '9', value: 'MUSHROOM FEE', text: 'MUSHROOM FEE' },
    { key: '10', value: 'WATERMELON FEE', text: 'WATERMELON FEE' },
    { key: '11', value: 'SHEEP FEE', text: 'SHEEP FEE' },
    { key: '12', value: 'BLUEBERRY FEE', text: 'BLUEBERRY FEE' },
    { key: '13', value: 'AVOCADO FEE', text: 'AVOCADO FEE' },
    { key: '14', value: 'MANGO FEE', text: 'MANGO FEE' },
    { key: '15', value: 'SORGHUM FEE', text: 'SORGHUM FEE' },
    { key: '16', value: 'DAIRY PRODUCT FEE', text: 'DAIRY PRODUCT FEE' },
    { key: '17', value: 'DISTILLED SPIRITS IR TAX', text: 'DISTILLED SPIRITS IR TAX' },
    { key: '18', value: 'WINES IR TAX', text: 'WINES IR TAX' },
    { key: '19', value: 'TOBACCO PRODUCTS IR TAX', text: 'TOBACCO PRODUCTS IR TAX' },
    { key: '20', value: 'OTHER IR TAX', text: 'OTHER IR TAX' },
    { key: '21', value: 'OTHER REVENUE', text: 'OTHER REVENUE' },
    { key: '22', value: 'DUTY', text: 'DUTY' },
    { key: '23', value: 'INTEREST', text: 'INTEREST' },
    { key: '24', value: 'FORMAL MERCHANDISE PROCESSING FEE', text: 'FORMAL MERCHANDISE PROCESSING FEE' },
    { key: '25', value: 'HARBOR MAINTENANCE FEE', text: 'HARBOR MAINTENANCE FEE' },
  ]

  const importerIdTypeData = [
    { key: '1', value: 'US_IRS_ID', text: 'IRS'},
    { key: '2', value: 'US_CBP_ID', text: 'CBP'},
    { key: '3', value: 'US_SSN', text: 'SSN'},
  ]

  const importerIdValidation = {
    "US_IRS_ID": {formatDescription:'NN-NNNNNNNXX',formatRegex:/^[0-9]{2}\-[0-9]{7}([ ]{0,2}|[a-zA-Z0-9]{2})$/},
    "US_CBP_ID": {formatDescription:'YYDDPP-NNNNN',formatRegex:/^\d{6}-\d{5}$/},
    "US_SSN": {formatDescription:'NNN-NN-NNNN',formatRegex:/^[0-9]{3}\-[0-9]{2}\-[0-9]{4}$/}
  }

  const displayMessages = {
    100: {color: "black", message: ""},
    101: {color: "red", message: "Something went wrong, please try again later"},
    201: {color: "green", message: "File Uploaded Successfully!"},
    202: {color: "red", message: "Please upload the correct format file."}
  }
export {
    reconHeaderData,
    reconStatusIndicatorData,
    reconTypeVal,
    actionTypeVal,
    importEntryLocVal,
    paymentTypeCodeVal,
    dropdownLabelVal,
    importerIdTypeData,
    importerIdValidation,
    displayMessages
}